import styles from './CourseIdea.module.css'

export default () => (
  <div className={styles.CourseIdea}>
    Have an idea for a new lesson? A question or a comment regarding an existing
    course lesson? Open an issue at{' '}
    <a
      href="https://github.com/bahmutov/cypress-courses"
      title="Cypress courses repo"
    >
      bahmutov/cypress-courses
    </a>
    .
  </div>
)
